import _isEqual from 'lodash.isequal';

// List is otherwise uncontrolled: it seeds selectedFilters in its constructor and pushes
// changes upward, never listening back down. That is fine while the filter panel is the only
// author of filter state. A parent that drives the filters — e.g. Traffic's summary cards —
// is a second author, and needs this.
//
// Compare the RAW props. List has no defaultProp for selectedFilters, so every consumer that
// does not pass it sees undefined forever; normalising to {} before comparing would make
// undefined look like a change and setState on every render.
//
// Compare DEEPLY. The filter object is rebuilt on most renders, so an identity check would
// absorb -> setState -> re-render -> absorb, without end.
export default function shouldAbsorbSelectedFilters(prevSelectedFilters, selectedFilters) {
  if (prevSelectedFilters === selectedFilters) {
    return false;
  }

  return !_isEqual(prevSelectedFilters, selectedFilters);
}
